// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3HLG3","paramInput":"JobSimulator_paramInput__25pSu","input":"JobSimulator_input__2CeVt"};